import { lazy } from "react";

export const Help = lazy(() => import("./Help"));
export const DemoHelp = lazy(() => import("./DemoHelp"));
//

export const HelpLanding = lazy(() => import("./HelpLanding"));

export const SignupHelp = lazy(() => import("./SignupHelp"));
